import React, { useState, useEffect } from "react";
import Card from "../../Components/scvpu/rsaDashboard/Card";
import CardSkeleton from "../../Components/scvpu/rsaDashboard/CardSkeleton";
import Accordian from "../../Components/scvpu/rsaDashboard/Accordian";
import ServiceRevenuePenetrationData from "../../Components/scvpu/rsaDashboard/ServiceRevenuePenetrationData";
import dealerScvBays from "../../Artifacts/scvpu/rsmDashboard/dealer_scv_bays.svg";
import dealerWorkshopImg from "../../Artifacts/scvpu/rsmDashboard/dealer_workshop_img.svg";
import rsmDealerImg from "../../Artifacts/scvpu/rsmDashboard/rsa_dealer_img.svg";
import ssoImg from "../../Artifacts/scvpu/rsmDashboard/sso_img.svg";
import stateImg from "../../Artifacts/scvpu/rsmDashboard/state_img.svg";
import tassScvBays from "../../Artifacts/scvpu/rsmDashboard/tass_scv_bays.svg";
import tassWorkshopImg from "../../Artifacts/scvpu/rsmDashboard/tass_workshop_img.svg";
import totalBaysImg from "../../Artifacts/scvpu/rsmDashboard/total_bays_img.svg";
import totalScvBays from "../../Artifacts/scvpu/rsmDashboard/total_scv_bays.svg";
import totalWorkshopImg from "../../Artifacts/scvpu/rsmDashboard/total_workshop_img.svg";
import serviceRevenuePenetration from "../../Artifacts/scvpu/rsmDashboard/service_revenue_penetration_img.svg";
import dealerProfitablity from "../../Artifacts/scvpu/rsmDashboard/dealer_profitability.svg";
import serviceQuality from "../../Artifacts/scvpu/rsmDashboard/service_quality.svg";
import DealerProfitablility from "../../Components/scvpu/rsaDashboard/DealerProfitablility";
import { axInst } from "../../Components/Login/Service";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import ServiceQuality from "../../Components/scvpu/rsaDashboard/ServiceQuality";

export const fetchRsmCardsData = async (filterData) => {
  const { data } = await axInst.post(
    "collbax-service/collbax_service_rsm_card",
    filterData,
  );
  return data;
};

const RsmDashboard = () => {
  const { data, submitted } = useSelector(
    (state) => state.filtersServiceCollabax,
  );

  const {
    data: rsmCardData,
    isLoading: rsmCardLoading,
    isFetching: rsmCardFetching,
  } = useQuery({
    queryKey: ["rsmCardsData", submitted],
    queryFn: () => fetchRsmCardsData(data),
  });

  // console.log("Service Revenue Data", rsmCardData);

  const formatTitle = (key) => key.toUpperCase().replace(/_/g, " ");

  const iconMapping = {
    total_state: stateImg,
    total_sso: ssoImg,
    total_dealer: rsmDealerImg,
    tass_workshop: tassWorkshopImg,
    dealer_workshop: dealerWorkshopImg,
    total_worshop: totalWorkshopImg,
    total_bays: totalBaysImg,
    dealer_scv_count: dealerScvBays,
    tass_scv_count: tassScvBays,
    total_scv_bays: totalScvBays,
  };

  const cardsData = Object.entries(rsmCardData || {}).map(([key, value]) => ({
    icon: iconMapping[key] || stateImg,
    title: formatTitle(key),
    value: value || 0,
  }));

  const currentLoading = rsmCardLoading || rsmCardFetching;

  return (
    <div className="w-full max-w-[100vw] overflow-x-hidden">
      <div
        data-pdf-cards
        className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 p-2"
      >
        {currentLoading
          ? Array(10)
              .fill(0)
              .map((_, index) => <CardSkeleton key={index} />)
          : cardsData.map((card, index) => (
              <Card
                key={index}
                title={card.title}
                value={card.value}
                icon={card.icon}
              />
            ))}
      </div>
      <div className="w-full max-w-full p-2">
        <div className="flex flex-col gap-6">
          <Accordian
            icon={serviceRevenuePenetration}
            title="Service Revenue Penetration"
          >
            <ServiceRevenuePenetrationData />
          </Accordian>
          <Accordian
            icon={dealerProfitablity}
            title="Dealer Profitability (SAR improvement)"
          >
            <DealerProfitablility />
          </Accordian>
          <Accordian icon={serviceQuality} title="Service Quality">
            <ServiceQuality />
          </Accordian>
        </div>
      </div>
    </div>
  );
};

export default RsmDashboard;
